import { render, staticRenderFns } from "./addpaymentConfig.vue?vue&type=template&id=fd20ee0c&"
import script from "./addpaymentConfig.vue?vue&type=script&lang=js&"
export * from "./addpaymentConfig.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\datacenter_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fd20ee0c')) {
      api.createRecord('fd20ee0c', component.options)
    } else {
      api.reload('fd20ee0c', component.options)
    }
    module.hot.accept("./addpaymentConfig.vue?vue&type=template&id=fd20ee0c&", function () {
      api.rerender('fd20ee0c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pakgConfig/components/addpaymentConfig.vue"
export default component.exports